import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import { heritage } from '@99designs/common/core/settings/colors';
import TrackClick from 'components/TrackClick';
import UserInviteButton from 'components/UserInviteButton';
import UserProfileButton from 'components/UserProfileButton';
import React from 'react';

interface Props {
    userId: number;
    isUserAvailable: boolean;
}

const UserInteractionCtas = ({ userId, isUserAvailable }: Props) => (
    <ButtonGroup variations={['stacked']}>
        <ButtonGroupItem>
            {isUserAvailable ? (
                <TrackClick event="Element Clicked On Design Overlay" element="Invite CTA">
                    <UserInviteButton userId={userId} />
                </TrackClick>
            ) : (
                <UserInviteButton userId={userId} isDisabled={true} />
            )}
        </ButtonGroupItem>
        <ButtonGroupItem style={{ color: heritage }}>
            <TrackClick event="Element Clicked On Design Overlay" element="Portfolio CTA">
                <UserProfileButton userId={userId} />
            </TrackClick>
        </ButtonGroupItem>
    </ButtonGroup>
);

export default UserInteractionCtas;



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/UserInteractionCtas.tsx